import type React from 'react';
import SharedLinkContent from 'src/SharedLinkPage/SharedLinkContent';
import styles from 'src/SharedLinkPage/SharedLinkLandingPageStyles';

interface SharedLinkLandingPageProps {
  mediaPage?: boolean;
}

const SharedLinkLandingPage = ({ mediaPage = false }: SharedLinkLandingPageProps): React.JSX.Element => {
  const classes = styles();
  const wrapperClass = !mediaPage ? classes.sharedLinkContentContainer : undefined;
  return (
    <div className={classes.sharedLinkPage}>
      <div className={wrapperClass}>
        <SharedLinkContent mediaPage={mediaPage} />
      </div>
    </div>
  );
};

export default SharedLinkLandingPage;
